import { render } from "./multiple.vue?vue&type=template&id=fa36b778&scoped=true"
import script from "./multiple.vue?vue&type=script&lang=js"
export * from "./multiple.vue?vue&type=script&lang=js"

import "./multiple.vue?vue&type=style&index=0&id=fa36b778&scoped=true&lang=css"

import exportComponent from "D:\\KMR\\KMRPAY\\vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa36b778"]])

export default __exports__